import {SelectedNewsSources} from "../../components/news-source-selector/model/SelectedNewsSources";
import {Predicate} from "../../../types/GenericTypes";
import {NewsHeadlineViewModel} from "../../models/NewsHeadlineViewModel";

export function buildSourceFilter(sources: SelectedNewsSources | null): Predicate<NewsHeadlineViewModel> {
    if (sources == null) {
        return () => true;
    } else {
        return (headline) => sources[headline.source] === true;
    }
}
